import { render } from "./RemoteDicomDevice.vue?vue&type=template&id=64cb2e38&scoped=true"
import script from "./RemoteDicomDevice.vue?vue&type=script&lang=js"
export * from "./RemoteDicomDevice.vue?vue&type=script&lang=js"

import exportComponent from "/Users/erik/IdeaProjects/reportx/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64cb2e38"]])

export default __exports__